<template>
	<div>  
		<table class="table table-hover">
			<thead>
				<tr>
					<th v-for="(col, index) in columns"
						@click="sortBy(col.key)"
						:class="{ active: sortKey == col.key }" :key="index">
						{{ col.value | capitalize }}
						<!-- <span class="arrow" :class="sortOrders[col.key] > 0 ? 'asc' : 'dsc'"></span> -->
					</th>
					<th v-if="actions.length > 0"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, i) in filteredData" :key="i" :class="getBindClass(item)">
					<td v-for="(col, index) in columns" :key="index" @click="cellClick(item)">
						{{item[col.key]}}
					</td>
					<td v-if="actions.length > 0">
						<span v-for="(button, j) in actions" :key="j" :title="button.name">
							<button :class="button.buttonClass" @click="button.actionBtn(item)" type="button" v-if="button.hide(item)" :title="button.name" :disabled="submited">                          
								<span v-if='!submited'>
									<b-icon :icon="button.icon" aria-hidden="true"></b-icon>
								</span>
								<span v-if='submited'>
									<b-spinner small></b-spinner>
								</span>
							</button>                      
						</span>                      
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'Grid',
		props: {
			data: Array,
			actions: Array,
			columns: Array,
			filterKey: String,
			submited: Boolean,
			getBindClass: {
				type: Function,
				default() {
					return "";
				}
			},
			cellClick: {
				type: Function,
				default() {
					return true;
				}
			}
		},
		data: function () {
			let sortOrders = {}
			/*this.columns.forEach(function (col) {
				sortOrders[col.key] = 1
			});*/
			return {
				sortKey: '',
				sortOrders: sortOrders
			}
		},
		computed: {
			filteredData: function () {
			let sortKey = this.sortKey
			let filterKey = this.filterKey && this.filterKey.toLowerCase()
			let order = this.sortOrders[sortKey] || 1
			let data = this.data;
			let columns = this.columns;
			if (filterKey) {
				data = data.filter(function (row) {
					return Object.keys(row).some(function (key) {
						return String(row[key]).toLowerCase().includes(filterKey) && columns.some(c => c.key == key)
					});
				});
			}
			if (sortKey) {
				data = data.slice().sort(function (a, b) {
					a = a[sortKey].toLowerCase();
					b = b[sortKey].toLowerCase();
					if(!isNaN(a)) {
						a = Number.parseInt(a);
						b = Number.parseInt(b);
					}
					return (a === b ? 0 : a > b ? 1 : -1) * order
				})
			}
			return data
			}
		},
		filters: {
			capitalize: function (str) {
				return str.charAt(0).toUpperCase() + str.slice(1)
			}
		},
		methods: {
			sortBy: function (key) {
				this.sortKey = key
				this.sortOrders[key] = this.sortOrders[key] * -1
			},
			/*getBindClass: function(item) {
				let clase = '';
				clase += item.destacada == 'SI' ? 'destacada ' : '';
				clase += item.destacado == 'SI' ? 'destacada ' : '';
				clase += item.activo == 'NO' ? 'desactivado' : '';
				return clase;
			}*/
		}
	}
</script>
<style scoped>
	/*.ea_table {
		border: none !important;
		display: block;
		overflow-y: hidden;
		box-sizing: border-box;
		float: left;
		width: 100%;
	}

	.ea_table tbody, thead {
		flex-direction: column;
		display: flex;
	}

	.ea_table tbody {
		overflow: auto;
	}

	.ea_table tr {
		display: flex;
	}

	.ea_table td, .ea_table th {
		text-align: left;
		font-size: 0.75rem;
		flex: 1;
		text-align: center;
	}

	.ea_table thead th {
		background-color: #42b983;
		color: #fff;
		cursor: pointer;
		user-select: none;  
		text-align: center;
		margin: 0px !important;
		text-transform: uppercase;
	}

	.ea_table th.active {
		color: #fff;
	}

	.ea_table tbody td:first-child {
		border-left: 1px solid #ddd;
	}

	.ea_table tbody td {
		border-top: none;
		border-bottom: 1px solid #ddd;
		min-width: 8rem !important;
		border-right: 1px solid #ddd;
		overflow: auto;
	}*/

	.ea_table td, .ea_table th {
		text-align: left;
		font-size: 0.75rem;
		flex: 1;
		text-align: center;
	}

	.ea_table thead th {
		background-color: #42b983;
		color: #fff;
		cursor: pointer;
		user-select: none;  
		text-align: center;
		margin: 0px !important;
		text-transform: uppercase;
		border: none;
		z-index: 1;
	}

	.ea_table th.active {
		color: #fff;
	}

	.ea_table tbody td:first-child {
		border-left: 1px solid #ddd;
	}

	.ea_table tbody td {
		border-top: none;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
		overflow: auto;
	}

	.ea_table {
		overflow-y: hidden;
		overflow-x: auto;
		box-sizing: border-box;
	}

	.ea_table thead tr th {
		position: sticky;
		top: 0;
	}


	.ea_table table {
		border-collapse: collapse;
	}
	
	.ea_table table {
		width: 100%;
		font-family: sans-serif;
	}
	/* table td {
		padding: 16px;
	} */
	.ea_table table td:last-child {
		min-width: 120px;
	}	

	.desactivado td {
		color: #8d8d8d;
		background-color: #efe9e9 !important;
	}

	.listo td {
		background-color: #effcd2 !important;
	}

	.danger td {
		background-color: #f3ac91 !important;
	}

	.destacada td {
		font-weight: bold;
	}

	.ea_table th.active .arrow {
		opacity: 1;
	}

	.arrow {
		display: inline-block;
		vertical-align: middle;
		width: 0;
		height: 0;
		margin-left: 5px;
		opacity: 0.66;
	}

	.arrow.asc {
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-bottom: 4px solid #fff;
	}

	.arrow.dsc {
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-top: 4px solid #fff;
	}

	.btn-xs, .btn-group-xs > .btn {
		padding: 1px 5px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px;
		margin-right: 5px;
	}

	.btn-xs {
		margin-right: 1px;
	}

	@media (max-width: 992px) {
		.ea_table thead th {
			min-width: 6rem;
		}

		/*.ea_table thead th:last-child {
			padding-left: 1rem !important;
			padding-right: 1.5rem !important;  
		}

		.ea_table tbody td {
			padding-left: 1rem !important;
			padding-right: 1rem !important;  
		}

		.ea_table tbody td:last-child {
			padding-left: 1.5rem !important;
			padding-right: 1.3rem !important;
		}*/

		.btn-xs {
			margin-left: 1rem;
		}
	}


	@media screen and (-ms-high-contrast:none)
	{
		*::-ms-backdrop, .ea_table thead th {
			width: 150px !important;    
			height: auto !important;     
		} /* IE11 */
		*::-ms-backdrop, .ea_table tbody td {
			width: 150px !important;  
			height: auto !important;     
			padding-top: 13px;
			padding-bottom: 10px;
		} /* IE11 */
	}
</style>
